<template>
  <vs-sidebar
    click-not-close
    position-right
    parent="body"
    default-index="1"
    color="primary"
    class="add-new-data-sidebar items-no-padding"
    spacer
    v-model="isSidebarActiveLocal"
  >
    <div class="flex items-center justify-between px-6 mt-6">
      <h4>{{ Object.entries(this.data).length === 0 ? "Create New" : "Update" }} Attack</h4>
      <feather-icon icon="XIcon" @click.stop="isSidebarActiveLocal = false" class="cursor-pointer"></feather-icon>
    </div>
    <vs-divider class="mb-0"></vs-divider>

    <ValidationObserver v-slot="{ invalid }">
      <component
        :is="scrollbarTag"
        class="scroll-area--data-list-add-new"
        :settings="settings"
        :key="$vs.rtl"
      >
        <div class="p-6">
          <template v-if="dataAttackType !== 'mitre'">
            <div class="w-full text-center vx-col">
              <span>Logo</span>
            </div>
            <Upload
              @on-success="success"
              @on-error="error"
              @on-delete="deleteImage"
              limit="1"
              width="95%"
            ></Upload>
          </template>

          <!-- Attack Type -->
          <vs-select
            :success="['mitre', 'custom'].indexOf(dataAttackType) !== -1"
            success-text="Attack type is valid."
            :danger="['mitre', 'custom'].indexOf(dataAttackType) === -1"
            danger-text="Select a attack type."
            placeholder="Select"
            class="w-full special-form"
            icon-no-border
            icon="icon icon-crosshair"
            icon-pack="feather"
            label="Attack Type"
            v-model="dataAttackType"
          >
            <vs-select-item value="mitre" text="Mitre Att&ck" />
            <vs-select-item value="custom" text="Custom Attack" />
          </vs-select>

          <!-- Languages -->
          <vs-select
            placeholder="Select"
            class="w-full special-form"
            icon-no-border
            multiple
            icon="icon icon-code"
            icon-pack="feather"
            label="Languages"
            v-model="dataLanguages"
          >
            <vs-select-item
              :key="index"
              :value="item._id"
              :text="item.name"
              v-for="(item,index) in dataLanguageOptions"
            />
          </vs-select>

          <!-- Available Packages -->
          <vs-select
            placeholder="Select"
            class="w-full special-form"
            icon-no-border
            icon="icon icon-package"
            icon-pack="feather"
            label="Available Packages"
            multiple
            v-model="dataPackages"
          >
            <vs-select-item
              :key="index"
              :value="item._id"
              :text="item.title"
              v-for="(item,index) in dataPackageOptions"
            />
          </vs-select>

          <!-- Name -->
          <ValidationProvider
            immediate
            name="name"
            rules="required|min:1|max:100"
            v-slot="{ errors }"
          >
            <vs-input
              name="name"
              icon-no-border
              icon="icon icon-shield"
              icon-pack="feather"
              label="Name"
              placeholder="Ex: WannaCry"
              v-model="dataName"
              class="w-full special-form"
              :success="errors.length === 0"
              success-text="Attack name is valid"
              :danger="errors.length > 0"
              :danger-text="errors[0]"
            />
          </ValidationProvider>

          <!-- Description -->
          <ValidationProvider
            immediate
            name="description"
            rules="required|min:1|max:1000"
            v-slot="{ errors }"
          >
            <vs-input
              name="description"
              icon-no-border
              icon="icon icon-activity"
              icon-pack="feather"
              label="Description"
              placeholder="Ex: WannaCry ransomware attack was a May 2017 worldwide cyberattack by the WannaCry ransomware cryptoworm, which targeted computers running the Microsoft Windows operating system by encrypting data and demanding ransom payments in the Bitcoin cryptocurrency"
              v-model="dataDescription"
              class="w-full special-form"
              :success="errors.length === 0"
              success-text="Attack description is valid"
              :danger="errors.length > 0"
              :danger-text="errors[0]"
            />
          </ValidationProvider>
          <template v-if="dataAttackType === 'mitre'">
            <vs-button
              @click="popupActive=true"
              color="primary"
              class="w-full special-form"
            >Add Techniques</vs-button>
            <p class="w-full special-form">Selected Techniques: {{dataTechniques.length}}</p>
          </template>

          

          <vs-popup fullscreen title="Mitre Att&ck Matrix" :active.sync="popupActive">
            <div class="table-responsive">
              <table class="table">
                <thead class="text-white bg-blue-800 thead">
                  <th v-for="(attack, index) in mitreAttackDetail" :key="index">{{attack.title}}</th>
                </thead>
                <tbody>
                  <tr>
                    <td v-for="(attack, index) in mitreAttackDetail" :key="index">
                      <div v-for="(technique, index) in attack.techniques" :key="index" style="font-size: .7rem;">
                        <div class="flex flex-col px-1 py-2 mb-4 text-center whitespace-no-wrap border border-dashed">
                          <button :class="getTechniqueClass(technique)" @click.prevent="selectDeselectTechnique(technique)" class="relative px-1 py-2 space-y-2 border hover:bg-success hover:text-white hover:border-transparent">
                            <button @click.prevent="showTechniqueInfo(technique)" class="absolute top-0 right-0 flex items-center justify-center w-5 h-4 bg-gray-700 rounded-bl-lg">
                              <i class="text-white fa fas fa-info"></i>
                            </button>
                            <p class="text-muted">{{technique.id}}</p>
                            <p class="font-semibold text-blue-dark" >{{technique.name}} {{technique.sub_techniques.length > 0 ? `(${technique.sub_techniques.length})` : ''}}</p>
                          </button>
                          <div class="px-4">
                            <button @click.prevent="technique.collapsed = !technique.collapsed" v-if="technique.sub_techniques.length > 0" class="px-2 py-2 font-semibold border border-t-0 rounded-b-lg">{{technique.collapsed ? 'hide' : 'show'}} sub-techniques</button>
                          </div>
                          <div v-if="technique.collapsed" class="flex flex-col px-4 mt-2 space-y-2">
                            <button :class="getSubtechniqueClass(sub_technique)" @click.prevent="selectDeselectSubtechnique(sub_technique)" v-for="sub_technique in technique.sub_techniques" :key="sub_technique.value" class="px-1 py-2 space-y-2 border hover:bg-success hover:text-white hover:border-transparent ">
                              <p class="text-muted">{{technique.id}}{{sub_technique.id}}</p>
                              <p class="font-semibold text-blue-dark" >{{sub_technique.name}}</p>
                            </button>
                          </div>
                        </div>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </vs-popup>

          <vs-popup :title="popup.data.name" :active.sync="popup.active" style="z-index: 99999 !important;">
            <p>{{popup.data.description}}</p>
          </vs-popup>

          <vs-alert :active="isError" class="mt-5" color="danger" icon="new_releases">
            <span>{{error_message}}</span>
          </vs-alert>
        </div>
      </component>
      <div class="flex flex-wrap items-center p-6" slot="footer">
        <vs-button
          class="mr-6"
          @click="updateAttack"
          :disabled="invalid"
          v-if="dataId !== ''"
        >Update</vs-button>
        <vs-button class="mr-6" @click="createAttack" :disabled="invalid" v-else>Create</vs-button>
        <vs-button type="border" color="danger" @click="isSidebarActiveLocal = false">Cancel</vs-button>
      </div>
    </ValidationObserver>
  </vs-sidebar>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import eventBus from '../../eventBus'
import Upload from '../upload/Upload'
import mitreData from '../../mitreDataUpdated'

export default {
  props: {
    isSidebarActive: {
      type: Boolean,
      required: true
    },
    data: {
      type: Object,
      default: () => {}
    }
  },
  components: {
    Upload,
    VuePerfectScrollbar
  },
  data () {
    return {
      isError: false,
      image_id: null,
      popupActive: false,
      error_message: '',
      dataId: '',
      dataAttackType: '',
      dataName: '',
      dataLogo: '',
      dataDescription: '',
      dataLanguages: [],
      dataLanguageOptions: [],
      dataPackages: [],
      dataPackageOptions: [],
      dataTechniques: [],
      dataCreatedAt: '',
      dataUpdatedAt: '',
      mitreAttackDetail: [],
      popup: {
        active: false,
        data: {
          name: '',
          description: ''
        }
      },
      settings: {
        // perfectscrollbar settings
        maxScrollbarLength: 60,
        wheelSpeed: 0.6
      }
    }
  },
  watch: {
    isSidebarActive (val) {
      this.mitreAttackDetail = JSON.parse(JSON.stringify(mitreData))
      this.loadLanguages()
      this.loadPackages()
      if (!val) return
      if (Object.entries(this.data).length === 0) {
        this.initValues()
      } else {
        // Edit comes here
        const {
          _id,
          name,
          logo,
          type,
          description,
          languages,
          packages,
          techniques,
          createdAt,
          updatedAt
        } = JSON.parse(JSON.stringify(this.data))
        this.dataId = _id
        this.dataLogo = logo
        this.dataDescription = description
        this.dataName = name
        this.dataAttackType = type
        this.dataLanguages = []
        languages.forEach((language) => {
          this.dataLanguages.push(language._id)
        })
        this.dataTechniques = techniques
        this.dataPackages = []
        packages.forEach((p) => {
          this.dataPackages.push(p._id)
        })
        techniques.forEach((t) => {
          this.mitreAttackDetail.forEach((tactic) => {
            tactic.techniques.forEach((technique) => {
              if (t.id == technique.id) {
                technique.selected = true
              }
            })
          })
        })
        this.dataCreatedAt = createdAt
        this.dataUpdatedAt = updatedAt
      }
    }
  },
  computed: {
    isSidebarActiveLocal: {
      get () {
        return this.isSidebarActive
      },
      set (val) {
        if (!val) {
          this.$emit('closeSidebar')
          this.initValues()
        }
      }
    },
    scrollbarTag () {
      return this.$store.getters.scrollbarTag
    }
  },
  methods: {
    showTechniqueInfo(technique){
      this.popup.active = true;
      this.popup.data = technique;
    },
    loadLanguages () {
      this.$http.get('/management/languages').then((res) => {
        if (res.data.status === true) {
          this.dataLanguageOptions = res.data.languages
        }
      })
    },
    loadPackages () {
      this.$http.get('/management/packages').then((res) => {
        if (res.data.status === true) {
          this.dataPackageOptions = res.data.packages
        }
      })
    },
    getTechniqueClass (technique) {
      if (this.dataTechniques.find((t) => t.id === technique.id)) {
        return 'bg-success text-white'
      } else {
        if(technique.sub_techniques.length > 0){
          let found = false;
          technique.sub_techniques.forEach(sub_technique => {
            if (this.dataTechniques.find((t) => t.id === sub_technique.value)) {
              found = true;
              return;
            }
          })
          if(found){
            return 'bg-warning';
          }
        }
      }
    },
    getSubtechniqueClass(sub_technique){
      if (this.dataTechniques.find((t) => t.id === sub_technique.value)) {
        return 'bg-success text-white'
      } else {
        return 'hover:bg-success'
      }
    },
    selectDeselectSubtechnique(subtechnique){
      if (this.dataTechniques.find((t) => t.id === subtechnique.value)) {
        this.dataTechniques = this.dataTechniques.filter(
          (e) => e.id !== subtechnique.value
        )
      } else {
        this.dataTechniques.push({
          id: subtechnique.value,
          name: subtechnique.name,
          description: subtechnique.description
        })
      }
    },
    selectDeselectTechnique (technique) {
      if (this.dataTechniques.find((t) => t.id === technique.id)) {
        this.dataTechniques = this.dataTechniques.filter(
          (e) => e.id !== technique.id
        )
      } else {
        this.dataTechniques.push(technique)
      }
    },
    success (data) {
      this.image_id = data.message
    },
    error (data) {
      this.$swal({
        position: 'bottom-start',
        icon: 'error',
        toast: true,
        title: data.data.message,
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true
      })
    },
    getImage () {
      return `${process.env.VUE_APP_BASE_URL}/images/${this.image_id}`
    },
    deleteImage (data) {
      if (this.image_id !== null) {
        this.$http
          .delete(`/images/${this.image_id}`)
          .then((res) => {
            this.$swal({
              position: 'bottom-start',
              icon: 'success',
              toast: true,
              title: 'Image successfully deleted.',
              showConfirmButton: false,
              timer: 3000,
              timerProgressBar: true
            })
          })
          .catch((err) => {
            this.$swal({
              position: 'bottom-start',
              icon: 'error',
              toast: true,
              title: err.response.message,
              showConfirmButton: false,
              timer: 3000,
              timerProgressBar: true
            })
          })
        this.image_id = null
      }
    },
    initValues () {
      if (this.data.id) return
      this.dataId = ''
      this.dataName = ''
      this.dataDescription = ''
      this.dataAttackType = ''
      this.dataLogo = ''
      this.dataCost = 0
      this.dataLanguages = []
      this.dataCreatedAt = ''
      this.dataUpdatedAt = ''
      this.dataTechniques = []
    },
    isEmpty (val) {
      if (val === null || val === '' || val === undefined) {
        return true
      }
      return false
    },
    checkForm () {
      let errors = false
      if (this.isEmpty(this.dataId) || this.isEmpty(this.dataName)) {
        errors = true
      }
      return errors
    },
    updateAttack () {
      if (!this.checkForm()) {
        const data = {
          _id: this.dataId,
          name: this.dataName,
          type: this.dataAttackType,
          packages: this.dataPackages,
          description: this.dataDescription
        }
        if (this.dataLanguages.length > 0) {
          data['languages'] = this.dataLanguages
        }
        if (this.dataTechniques.length > 0 && this.dataAttackType === 'mitre') {
          data['techniques'] = this.dataTechniques
        }
        if (this.image_id !== null && this.dataAttackType !== 'mitre') {
          data['logo'] = this.image_id
        }
        this.$http
          .put('/management/attacks', data)
          .then((res) => {
            eventBus.$emit('refresh-attacks')
            if (res.data.status === true) {
              this.$emit('closeSidebar')
              this.initValues()
              this.$swal({
                position: 'bottom-start',
                icon: 'success',
                toast: true,
                title: 'Attack successfully updated.',
                showConfirmButton: false,
                timer: 1500,
                timerProgressBar: true
              })
            } else {
              this.$swal({
                position: 'bottom-start',
                icon: 'error',
                toast: true,
                title: 'Error occurred updating the attack.',
                showConfirmButton: false,
                timer: 1500,
                timerProgressBar: true
              })
            }
          })
          .catch((err) => {
            this.$swal({
              position: 'bottom-start',
              icon: 'error',
              toast: true,
              title: err.response.data.message,
              showConfirmButton: false,
              timer: 1500,
              timerProgressBar: true
            })
          })
      } else {
        this.error_message = 'Please make sure form is correct.'
        this.isError = true
      }
    },
    createAttack () {
      const data = {
        name: this.dataName,
        logo: this.image_id,
        type: this.dataAttackType,
        packages: this.dataPackages,
        description: this.dataDescription,
        languages: this.dataLanguages
      }
      if (this.dataAttackType === 'mitre') {
        data['techniques'] = this.dataTechniques
        data['logo'] = null
      }
      if (this.dataLanguages.length > 0) {
        if (this.dataAttackType === 'mitre' || this.image_id !== null) {
          this.$http
            .post('/management/attacks', data)
            .then((res) => {
              eventBus.$emit('refresh-attacks')
              if (res.data.status === true) {
                this.$emit('closeSidebar')
                this.initValues()
                this.$swal({
                  position: 'bottom-start',
                  icon: 'success',
                  toast: true,
                  title: 'Attack successfully created.',
                  showConfirmButton: false,
                  timer: 1500,
                  timerProgressBar: true
                })
              } else {
                this.$swal({
                  position: 'bottom-start',
                  icon: 'error',
                  toast: true,
                  title: 'Error occurred creating the attack.',
                  showConfirmButton: false,
                  timer: 1500,
                  timerProgressBar: true
                })
              }
            })
            .catch((err) => {
              this.$swal({
                position: 'bottom-start',
                icon: 'error',
                toast: true,
                title: err.response.data.message,
                showConfirmButton: false,
                timer: 1500,
                timerProgressBar: true
              })
            })
        } else {
          this.isError = true
          this.error_message = 'You must upload a logo for the custom attack.'
        }
      } else {
        this.isError = true
        this.error_message =
          'You must select at least 1 programming language to continue.'
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.special-form {
  margin-top: 1.5rem;
}
.add-new-data-sidebar {
  ::v-deep .vs-sidebar--background {
    z-index: 52010;
  }

  ::v-deep .vs-sidebar {
    z-index: 52010;
    width: 400px;
    max-width: 90vw;

    .img-upload {
      margin-top: 2rem;

      .con-img-upload {
        padding: 0;
      }

      .con-input-upload {
        width: 100%;
        margin: 0;
      }
    }
  }
}

.scroll-area--data-list-add-new {
  // height: calc(var(--vh, 1vh) * 100 - 4.3rem);
  height: calc(var(--vh, 1vh) * 100 - 16px - 45px - 82px);

  &:not(.ps) {
    overflow-y: auto;
  }
}

.table {
  width: 100%;
  margin-bottom: 1rem;
  color: #212529;
}

.table th,
.table td {
  padding: 0.75rem;
  vertical-align: top;
  border-top: 1px solid #dee2e6;
}

.table thead th {
  text-align: center;
  vertical-align: bottom;
  border-bottom: 2px solid #dee2e6;
}

.table tbody + tbody {
  border-top: 2px solid #dee2e6;
}

.table-sm th,
.table-sm td {
  padding: 0.3rem;
}

.table-bordered {
  border: 1px solid #dee2e6;
}

.table-bordered th,
.table-bordered td {
  border: 1px solid #dee2e6;
}

.table-bordered thead th,
.table-bordered thead td {
  border-bottom-width: 2px;
}

.table-borderless th,
.table-borderless td,
.table-borderless thead th,
.table-borderless tbody + tbody {
  border: 0;
}

.table-striped tbody tr:nth-of-type(odd) {
  background-color: rgba(0, 0, 0, 0.05);
}

.table-hover tbody tr:hover {
  color: #212529;
  background-color: rgba(0, 0, 0, 0.075);
}

.table-primary,
.table-primary > th,
.table-primary > td {
  background-color: #b8daff;
}

.table-primary th,
.table-primary td,
.table-primary thead th,
.table-primary tbody + tbody {
  border-color: #7abaff;
}

.table-hover .table-primary:hover {
  background-color: #9fcdff;
}

.table-hover .table-primary:hover > td,
.table-hover .table-primary:hover > th {
  background-color: #9fcdff;
}

.table-secondary,
.table-secondary > th,
.table-secondary > td {
  background-color: #d6d8db;
}

.table-secondary th,
.table-secondary td,
.table-secondary thead th,
.table-secondary tbody + tbody {
  border-color: #b3b7bb;
}

.table-hover .table-secondary:hover {
  background-color: #c8cbcf;
}

.table-hover .table-secondary:hover > td,
.table-hover .table-secondary:hover > th {
  background-color: #c8cbcf;
}

.table-success,
.table-success > th,
.table-success > td {
  background-color: #c3e6cb;
}

.table-success th,
.table-success td,
.table-success thead th,
.table-success tbody + tbody {
  border-color: #8fd19e;
}

.table-hover .table-success:hover {
  background-color: #b1dfbb;
}

.table-hover .table-success:hover > td,
.table-hover .table-success:hover > th {
  background-color: #b1dfbb;
}

.table-info,
.table-info > th,
.table-info > td {
  background-color: #bee5eb;
}

.table-info th,
.table-info td,
.table-info thead th,
.table-info tbody + tbody {
  border-color: #86cfda;
}

.table-hover .table-info:hover {
  background-color: #abdde5;
}

.table-hover .table-info:hover > td,
.table-hover .table-info:hover > th {
  background-color: #abdde5;
}

.table-warning,
.table-warning > th,
.table-warning > td {
  background-color: #ffeeba;
}

.table-warning th,
.table-warning td,
.table-warning thead th,
.table-warning tbody + tbody {
  border-color: #ffdf7e;
}

.table-hover .table-warning:hover {
  background-color: #ffe8a1;
}

.table-hover .table-warning:hover > td,
.table-hover .table-warning:hover > th {
  background-color: #ffe8a1;
}

.table-danger,
.table-danger > th,
.table-danger > td {
  background-color: #f5c6cb;
}

.table-danger th,
.table-danger td,
.table-danger thead th,
.table-danger tbody + tbody {
  border-color: #ed969e;
}

.table-hover .table-danger:hover {
  background-color: #f1b0b7;
}

.table-hover .table-danger:hover > td,
.table-hover .table-danger:hover > th {
  background-color: #f1b0b7;
}

.table-light,
.table-light > th,
.table-light > td {
  background-color: #fdfdfe;
}

.table-light th,
.table-light td,
.table-light thead th,
.table-light tbody + tbody {
  border-color: #fbfcfc;
}

.table-hover .table-light:hover {
  background-color: #ececf6;
}

.table-hover .table-light:hover > td,
.table-hover .table-light:hover > th {
  background-color: #ececf6;
}

.table-dark,
.table-dark > th,
.table-dark > td {
  background-color: #c6c8ca;
}

.table-dark th,
.table-dark td,
.table-dark thead th,
.table-dark tbody + tbody {
  border-color: #95999c;
}

.table-hover .table-dark:hover {
  background-color: #b9bbbe;
}

.table-hover .table-dark:hover > td,
.table-hover .table-dark:hover > th {
  background-color: #b9bbbe;
}

.table-active,
.table-active > th,
.table-active > td {
  background-color: rgba(0, 0, 0, 0.075);
}

.table-hover .table-active:hover {
  background-color: rgba(0, 0, 0, 0.075);
}

.table-hover .table-active:hover > td,
.table-hover .table-active:hover > th {
  background-color: rgba(0, 0, 0, 0.075);
}

.table .thead-dark th {
  color: #fff;
  background-color: #343a40;
  border-color: #454d55;
}

.table .thead-light th {
  color: #495057;
  background-color: #e9ecef;
  border-color: #dee2e6;
}

.table-dark {
  color: #fff;
  background-color: #343a40;
}

.table-dark th,
.table-dark td,
.table-dark thead th {
  border-color: #454d55;
}

.table-dark.table-bordered {
  border: 0;
}

.table-dark.table-striped tbody tr:nth-of-type(odd) {
  background-color: rgba(255, 255, 255, 0.05);
}

.table-dark.table-hover tbody tr:hover {
  color: #fff;
  background-color: rgba(255, 255, 255, 0.075);
}

@media (max-width: 575.98px) {
  .table-responsive-sm {
    display: block;
    width: 100%;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
  .table-responsive-sm > .table-bordered {
    border: 0;
  }
}

@media (max-width: 767.98px) {
  .table-responsive-md {
    display: block;
    width: 100%;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
  .table-responsive-md > .table-bordered {
    border: 0;
  }
}

@media (max-width: 991.98px) {
  .table-responsive-lg {
    display: block;
    width: 100%;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
  .table-responsive-lg > .table-bordered {
    border: 0;
  }
}

@media (max-width: 1199.98px) {
  .table-responsive-xl {
    display: block;
    width: 100%;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
  .table-responsive-xl > .table-bordered {
    border: 0;
  }
}

.table-responsive {
  display: block;
  width: 100%;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
}

.table-responsive > .table-bordered {
  border: 0;
}

.table-responsive {
  display: block;
  width: 100%;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
}

.table-responsive > .table-bordered {
  border: 0;
}
</style>